import { QuoteResponse } from '../../models/services/api/postQuote';
import { QuoteDiscountTerms } from '../../pages/QuotePage/QuotePage.types';

export const getDiscountDisplayData = (quote: QuoteResponse): QuoteDiscountTerms => {
  let discountPaymentType: 'cc' | 'ach' | undefined;

  if (quote?.offer.contracts[0]?.contractAttributes.subscription?.ach.discountProfileAttributes) {
    discountPaymentType = 'ach';
  }

  if (quote?.offer.contracts[0]?.contractAttributes.subscription?.cc.discountProfileAttributes) {
    discountPaymentType = 'cc';
  }

  return {
    discountTerm: discountPaymentType
      ? quote.offer.contracts[0].contractAttributes.subscription[discountPaymentType]
          .discountProfileAttributes?.discountTerm
      : undefined,
    discountPercentage: discountPaymentType
      ? (quote.offer.contracts[0].contractAttributes.subscription[discountPaymentType]
          .discountProfileAttributes?.discountPercentage || 0) * 100
      : undefined,
    netFirstPaymentAmount:
      quote.offer.contracts[0].contractAttributes.subscription[discountPaymentType ?? 'ach']
        .netFirstPaymentAmount,
    netFirstPaymentAmountAfterPromotionalPeriod: discountPaymentType
      ? quote.offer.contracts[0].contractAttributes.subscription[discountPaymentType]
          .discountProfileAttributes?.netFirstPaymentAmountAfterPromotionalPeriod
      : undefined,
    periodOfCover: quote.offer.contracts[0].contractAttributes.periodOfCover,
    discountPaymentType: discountPaymentType,
  };
};
